export default function () {
  const widgetName = 'signupWidget';
  const widgetOpts = signupWidgetOpts;

  function modifySignup() {
    const submitBtn = $('.emailSubmitButton');
    const signupBtn = $(`#${widgetName}`).find('.moreButton');

    signupBtn.on('keypress click', function (e) {
      e.preventDefault();
      submitBtn.click();
    });
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function () {
      modifySignup();
      if ($(`#${widgetName} .card-widget-item`).length === 0) {
        $('.signup-section').remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'SIGN UP',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
